import React, { useState } from "react";
import { Button, Col, Flex, Form, Row, Upload, notification } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { api } from "../utils/Api";
import axios from "axios";

const AddProjectBond = ({ jobId, pcb }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onFinish = async (values) => {
		try {
			setLoading(true);
			const formData = new FormData();

			if (values.projectBondEvidence && values.projectBondEvidence.length > 0) {
				formData.append(
					"projectBondEvidence",
					values.projectBondEvidence[0].originFileObj
				);
			}

			const url = api + `/job/add/project/evidence/${jobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					pcb();
				}, 2000);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
				return null;
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to upload evidence"
			);
			return null;
		}
	};

	const CustomForm = () => (
		<Form
			form={form}
			layout="vertical"
			style={{ marginTop: "20px" }}
			onFinish={onFinish}
		>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item
						label="Evidence"
						name="projectBondEvidence"
						valuePropName="fileList"
						getValueFromEvent={normFile}
						rules={[
							{
								required: true,
								message: "Evidence is required",
							},
						]}
					>
						<Upload
							beforeUpload={() => false}
							maxCount={1}
							multiple={false}
							accept=".png, .jpg, .jpeg, .pdf"
						>
							<Button
								icon={<UploadOutlined />}
								size="large"
								style={{
									width: "100%",
								}}
								type="default"
							>
								Upload
							</Button>
						</Upload>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						loading={loading}
						disabled={loading}
					>
						Save
					</Button>
				</Col>
			</Row>
		</Form>
	);

	return (
		<div>
			<Flex vertical gap={"middle"}>
				<CustomForm />
				{contextHolder}
			</Flex>
		</div>
	);
};

export default AddProjectBond;
